// פירוק SSE טהור (בלי DOM) — נבדק ב-vitest.
export type SseMessage = { id: string | null; event: string; data: string };

/** מפרק זרם טקסט ל-frames של SSE (שורות id/event/data; שורה ריקה סוגרת; ':' = הערה — נמסרת ל-onComment אם ביקשו). */
export function createSseParser(onFrame: (m: SseMessage) => void, onComment?: (text: string) => void) {
  let buf = '';
  let id: string | null = null;
  let event = 'message';
  let data: string[] = [];
  return (chunk: string) => {
    buf += chunk;
    let nl: number;
    while ((nl = buf.search(/\r\n|\n|\r/)) >= 0) {
      const line = buf.slice(0, nl);
      buf = buf.slice(nl + (buf[nl] === '\r' && buf[nl + 1] === '\n' ? 2 : 1));
      if (line === '') {
        if (data.length) onFrame({ id, event, data: data.join('\n') });
        id = null;
        event = 'message';
        data = [];
        continue;
      }
      if (line.startsWith(':')) {
        onComment?.(line.slice(1).trim());
        continue;
      }
      const i = line.indexOf(':');
      const field = i < 0 ? line : line.slice(0, i);
      const value = i < 0 ? '' : line.slice(i + 1).replace(/^ /, '');
      if (field === 'id') id = value;
      else if (field === 'event') event = value;
      else if (field === 'data') data.push(value);
    }
  };
}
